import { WINDOW } from "AtomicUtils/environment"
import cookieHandler from "AtomicUtils/cookieHandler"

const gtmHandler = ({
  pageCategory = "",
  pageAction = ""
}) => {
  if (WINDOW) {
    if (!WINDOW.dataLayer) WINDOW.dataLayer = []

    const newData = {
      event: "reactjs.event",
      pageCategory: pageCategory,
      pageAction: pageAction
    }

    let cookieHandlerObject = new cookieHandler();
    if (cookieHandlerObject.getCookie("userId")) {
      newData.userId = cookieHandlerObject.getCookie("userId")
    }

    if (process && process.env && process.env.NODE_ENV === "development") {
      console.table({
        GTM_CALL: {
          Category: newData.pageCategory,
          Action: newData.pageAction,
          UserId: newData.userId || 'guest'
        }
      })
    }

    WINDOW.dataLayer.push(newData)
  }
}


export default gtmHandler



// WEBPACK FOOTER //
// ./src/AtomicUtils/gtmHandler.js